export const OUTROS = "Outros";

export const ASSUNTOS_POR_ETAPA = {
  "Planejamento": ["Fertilidade", "Saúde pré-concepcional", "Nutrição", "Saúde emocional", "Planejamento financeiro", "Exames e vacinas"],
  "Gestação": ["Pré-natal", "Nutrição", "Saúde emocional", "Exames", "Atividade física", "Preparação para o parto"],
  "Parto": ["Plano de parto", "Tipos de parto", "Doula", "Escolha da maternidade", "Acompanhante", "Alívio da dor"],
  "Pós-parto": ["Amamentação", "Sono do bebê", "Recuperação física", "Saúde emocional", "Primeiros cuidados", "Rede de apoio"],
};

export function expandAssuntos(assuntos = [], outrosTexto = "") {
  return assuntos.flatMap((a) =>
    a === OUTROS ? (outrosTexto.trim() ? [`Outros: ${outrosTexto.trim()}`] : ["Outros"]) : [a]
  );
}
